import React, { useContext } from 'react';
import { ParamsProviderState } from './params.types';

export const ParamsContext = React.createContext<ParamsProviderState>({
  portalType: undefined,
  utm: undefined,
  activeIcon: undefined,
  locale: undefined,
  user: {
    applicant_id: undefined,
    company_name: undefined,
    title: undefined,
    name: undefined,
    surname: undefined,
    email: undefined,
    phone: undefined
  },
  pages: {
    success: undefined,
    success_partner_prospects: undefined,
    success_client_prospects: undefined,
    faq: undefined
  }
});

export const useParamsContext = (): ParamsProviderState =>
  useContext(ParamsContext);
